import { TopMenuItem } from "~/models/menu";
import { MenuItemChildren } from "./MenuItemChildren";

/**
 * mimic the mega menu layout for AEM which has 4 columns of items, each row is
 * either left-to-right or right-to-left depending on the row index.
 */
export function MegaSubMenuRow({
  col,
  dir,
}: {
  col: TopMenuItem[];
  dir?: "ltr" | "rtl";
}) {
  if (dir === "rtl") {
    // if columns is less than 4, we need to add empty columns to make it 4
    while (col.length < 4) {
      col.push({ id: -1, title: "", url: "", children: [] });
    }

    col = [...col].reverse();
  }

  return (
    <>
      <div className="tw:w-full tw:grid tw:grid-cols-4 tw:gap-2 tw:my-1">
        {col!.map((child, index) => (
          <div key={index}>
            {child.id === -1 ? (
              <div className="tw:flex tw:flex-col"></div>
            ) : (
              <div className="tw:flex tw:flex-col">
                <a
                  href={child.url}
                  className="tw:flex tw:flex-col tw:px-4 tw:py-3 tw:rounded-lg tw:no-underline! tw:text-gray-900 tw:text-semibold! tw:hover:text-blue-500! tw:hover:underline! tw:group tw:transition-colors tw:duration-100"
                >
                  <span className="tw:text-base tw:uppercase tw:font-semibold! group-hover:tw:text-blue-600 tw:transition-colors">
                    {child.title}
                  </span>
                </a>

                <MenuItemChildren item={child} />
              </div>
            )}
          </div>
        ))}
      </div>
    </>
  );
}
